<div class="subBlockContainer">
    <div id="renewal-container"> 
        <div class="subBlockContent" id="renewalDetails">
            <child-header [title]="manageRenewal?.RenewalDetails?.endUser" (closeEvent)="close()"></child-header>
            <div #ParentWrapper class="child-body">
                <div style="background-color: white;padding: 20px;height: 100px;">
                    <div class="page-title-wrapper">
                        <!-- <div class="title blade-title-font">
                            {{manageRenewal?.RenewalDetails?.endUser}}
                        </div>
                        <i class="material-icons closebutton-pullfloat-right" (click)="close()">close</i> -->
                        <img class="page-title-img" [attr.src]="vendorDictionary[manageRenewal?.RenewalDetails?.vendor]">
                    </div>
                </div>
                <div class="item-title-wrapper">

                    <!-- <div class="page-title-wrapper">
                    <div class="title blade-title-font">
                        {{manageRenewal?.RenewalDetails?.endUser}}
                    </div>
                    <i class="material-icons closebutton-pullfloat-right" (click)="close()">close</i>
                    <img class="page-title-img" [src]="vendorDictionary[manageRenewal?.RenewalDetails?.vendor]">
                </div>

                <div class="top-divider"></div> -->

                    <loading-screen *ngIf="!loadContent" [showBlurTable]="true"
                        (currentLoadingStatus)="onLoading($event)"></loading-screen>


                    <div *ngIf="loadContent" class="pannel-outter-wrapper">


                        <div class="wrapper center-block">
                            <div class="panel-group" id="accordionOne" role="tablist" aria-multiselectable="true">
                                <div class="panel panel-default">
                                    <div class="panel-heading active" role="tab" id="headingOne">
                                        <h4 class="panel-title">
                                            <a role="button" data-toggle="collapse" data-parent="#accordionOne"
                                                href="#collapseOne" aria-expanded="false" aria-controls="collapseOne">
                                                <span class="highlight-text">
                                                    {{manageRenewal?.RenewalDetails?.title}}
                                                    <span class="text-float-right">VENDOR :
                                                        {{manageRenewal?.RenewalDetails?.vendor}} | PROGRAM :
                                                        {{manageRenewal?.RenewalDetails?.program}}
                                                        {{ renderAreegmentNumber(manageRenewal?.RenewalDetails.agreementNumber)}}
                                                        | END USER :
                                                        {{manageRenewal?.RenewalDetails?.endUser}}<span
                                                            class="panel-subtitle" id="panelsubtitle">
                                                            <span class="triangle-down"></span>
                                                        </span></span>

                                                </span>
                                                <!-- <span class="highlight-text">
                                                    {{manageRenewal?.RenewalDetails?.title}}
                                                    <span class="text-float-right">
                                                        {{manageRenewal?.RenewalDetails?.vendor}} |
                                                        {{manageRenewal?.RenewalDetails?.program}}
                                                        {{ renderAreegmentNumber(manageRenewal?.RenewalDetails.agreementNumber)}}
                                                        | {{manageRenewal?.RenewalDetails?.endUser}}<span
                                                            class="panel-subtitle" id="panelsubtitle">
                                                            <span class="triangle-down"></span>
                                                        </span></span>

                                                </span> -->
                                            </a>
                                        </h4>
                                        <div id="collapseOne" class="panel-collapse collapse in show" role="tabpanel"
                                            aria-labelledby="headingOne">
                                            <div class="panel-body">
                                                <div class="panel-content">

                                                    <div class="row">
                                                        <div class="col-sm">
                                                            <label class="lable-title">VENDOR</label>
                                                            <p class="paragraph-text">
                                                                {{manageRenewal?.RenewalDetails?.vendor}}
                                                            </p>
                                                        </div>
                                                        <div class="col-sm">
                                                            <label class="lable-title"> PROGRAM</label>
                                                            <p class="paragraph-text">
                                                                {{manageRenewal?.RenewalDetails?.program}}
                                                            </p>
                                                        </div>
                                                        <div class="col-sm">
                                                            <label class="lable-title"> EXPIRY DATE</label>
                                                            <p class="paragraph-text">
                                                                {{manageRenewal?.RenewalDetails?.expiryDate}}</p>
                                                        </div>
                                                    </div>

                                                    <div class="row">
                                                        <div class="col-sm">
                                                            <label class="lable-title">END USER</label>
                                                            <p class="paragraph-text textUpperCase">
                                                                {{manageRenewal?.RenewalDetails?.endUser}}</p>
                                                        </div>

                                                        <ng-container
                                                            *ngIf="manageRenewal?.RenewalDetails.agreementNumber;else nullAgreement">
                                                            <div class="col-sm">
                                                                <label class="lable-title">AGREEMENT NUMBER</label>
                                                                <p class="paragraph-text textUpperCase">
                                                                    {{manageRenewal?.RenewalDetails?.agreementNumber}}</p>
                                                            </div>
                                                            <div class="col-sm">
                                                                <label class="lable-title">CUSTOMER REFERENCE</label>
                                                                <p class="paragraph-text textUpperCase">
                                                                    {{manageRenewal?.RenewalDetails?.reference}}</p>
                                                            </div>
                                                        </ng-container>


                                                        <ng-template #nullAgreement>

                                                            <div class="col-sm">
                                                                <label class="lable-title">CUSTOMER REFERENCE</label>
                                                                <p class="paragraph-text textUpperCase">
                                                                    {{manageRenewal?.RenewalDetails?.reference}}</p>
                                                            </div>
                                                            <div class="col-sm">

                                                            </div>
                                                        </ng-template>

                                                    </div>

                                                    <div class="row">
                                                        <div class="col-sm">
                                                            <div>
                                                                <label class="lable-title">OPPORTUNITY ID</label>
                                                                <p class="paragraph-text textUpperCase">
                                                                    {{manageRenewal?.RenewalDetails?.opportunityId}}</p>
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="wrapper center-block panel-wrapper-margin">
                            <div class="panel-group" id="accordionOne" role="tablist" aria-multiselectable="true">
                                <div class="panel panel-default">
                                    <div class="panel-heading active" role="tab" id="headingOne">
                                        <h4 class="panel-title">
                                            <a role="button" data-toggle="collapse" data-parent="#accordionOne"
                                                href="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                                <span class="highlight-text">
                                                    {{manageRenewal?.RenewalManagement?.title}}
                                                    <span class="panel-subtitle" id="panelsubtitle">
                                                        <span class="triangle-down"></span>
                                                    </span>
                                                </span>
                                            </a>
                                        </h4>
                                        <div id="collapseTwo" class="panel-collapse collapse in show" role="tabpanel"
                                            aria-labelledby="headingOne">
                                            <div class="panel-body">
                                                <div class="panel-content">

                                                    <div class="row">
                                                        <div class="col-4">
                                                            <label class="lable-title">STATUS</label>
                                                            <div>
                                                                <ng-select [items]="statusList" bindLabel="out_tbl_code"
                                                                    [clearable]="false" placeholder="Select status"
                                                                    [(ngModel)]="status">
                                                                </ng-select>
                                                            </div>
                                                        </div>

                                                        <div class="col-8">
                                                            <label class="lable-title"> COMMENTS</label>
                                                            <div>
                                                                <textarea maxlength="300" class="comments"
                                                                    placeholder="Use this space to add a status and comments to this renewal opportunity.so you can keep track of your renewal pipeline."
                                                                    [(ngModel)]="comments"></textarea>
                                                            </div>

                                                        </div>

                                                    </div>
                                                    <div class="row">
                                                        <div class="col-sm"></div>
                                                        <div class="col-sm">
                                                        </div>
                                                    </div>
                                                    <div class="d-flex justify-content-center">
                                                        <button class="button button-red button-large renewalStatusButton"
                                                            (click)="updateRenewalStatus()">Update</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <ng-container *ngFor="let option of manageRenewal.Options;index as i">



                            <div class=" wrapper center-block panel-wrapper-margin">
                                <div class="panel-group" id="i" role="tablist" aria-multiselectable="true">
                                    <div class="panel panel-default">
                                        <div class="panel-heading active" role="tab" id="headingTwo">
                                            <h4 class="panel-title">
                                                <a role="button" class="accordionHeight" data-toggle="collapse"
                                                    href="{{'#collapse' + i}}" aria-expanded="false"
                                                    aria-controls="collapseTwo">
                                                    <span class="highlight-text">
                                                        OPTION {{ i + 1 }} <span class="textUpperCase"> -
                                                            {{ option.desc }}</span>
                                                        <span class="panel-subtitle" id="panelsubtitle">
                                                            <b>TOTAL (Ex GST) - </b> {{ option.total | currency }}
                                                            <span class="triangle-down"></span>
                                                        </span>
                                                    </span>
                                                </a>
                                            </h4>
                                            <div id="{{'collapse' + i}}" class="panel-collapse collapse in"
                                                [class.show]="manageRenewal.Options.length==1?true:false" role="tabpanel"
                                                aria-labelledby="headingTwo" data-parent="#accordionGroup">
                                                <div class="panel-body">
                                                    <div class="panel-content">
                                                        <div class="mTable">
                                                            <table class="table display-block">
                                                                <thead>
                                                                    <tr>
                                                                        <th scope="col"></th>
                                                                        <th scope="col">STOCK CODE</th>
                                                                        <th scope="col">DESCRIPTION</th>
                                                                        <th scope="col" class="align-center">QTY</th>
                                                                        <th scope="col" class="align-right">PRICE</th>
                                                                        <th scope="col" class="align-right">EXTENDED PRICE</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    <tr *ngFor="let item of option.details; index as i">
                                                                        <td style="width: 10%;">
                                                                            <div class="checkbox-center" *ngIf="showSlideToggle(option.action)">
                                                                                <mat-slide-toggle
                                                                                    [disabled]="!(user$|async)?.hasAdminAccess && !(user$|async)?.hasPurchaseAccess"
                                                                                    [matTooltipDisabled]="(user$|async)?.hasAdminAccess || (user$|async)?.hasPurchaseAccess"	
                                                                                    matTooltip="Requires Purchasing Permissions"
                                                                                    [(ngModel)]="item.isSelected">
                                                                                </mat-slide-toggle>
                                                                            </div>
                                                                        </td>
                                                                        <td style="width: 25%">
                                                                            {{ item?.stokeCode }}
                                                                        </td>
                                                                        <td style="width: 40%"> {{ item?.description }}
                                                                            <br>
                                                                            <span class="serial-text">Serial:
                                                                                {{ item?.serialNumber }}</span>
                                                                        </td>
                                                                        <td>
                                                                            <input integerOnly
                                                                                [disabled]="(item.minQty==0)&&(item.maxQty==0)"
                                                                                class="align-center input-wrapper input-wrapper-small"
                                                                                type="text" [(ngModel)]="item.qty"
                                                                                (ngModelChange)="optionQtyonChange(option,i)">
                                                                        </td>
                                                                        <td class="align-right"  style="width: 10%">
                                                                            {{ item?.price | number: '1.2-2' }}
                                                                        </td>
                                                                        <td class="align-right" style="width: 20%">
                                                                            {{ item?.extendedPrice | number: '1.2-2' }}
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                                <tfoot>
                                                                    <div class="row totalPrice-wrapper">
                                                                        <div class="col align-center">
        
                                                                        </div>
                                                                        <div class="col align-center">
                                                                            <span><b>TOTAL (Ex GST) - </b>
                                                                                {{ option.total | currency }}</span>
                                                                        </div>
                                                                    </div>
                                                                </tfoot>
                                                                
                                                            </table>
                                                            <div class="purchaseBtn align-center">

                                                                <!-- <button type="button" class="btn btn-primary" data-toggle="modal" data-target="#exampleModalCenter">
                                                                    Launch demo modal
                                                                </button> -->

                                                                <button id="btnPurchase"                                                                 class="button button-red button-large"
                                                                    (click)="open(null,option,i)"
                                                                    [disabled]="!option.canPurchase||fitlerOptions(option)">Enquiry</button>

                                                                <button id="btnPurchase"
                                                                    *ngIf="option.isTransactable"
                                                                    class="button button-red button-large"
                                                                    (click)="confirmRenewalPurchase(option)"
                                                                    [disabled]="!option.canPurchase || fitlerOptions(option) || (!(user$|async)?.hasAdminAccess && !(user$|async)?.hasPurchaseAccess)"
                                                                    [matTooltipDisabled]="(user$|async)?.hasAdminAccess || (user$|async)?.hasPurchaseAccess"	
                                                                    matTooltip="Requires Purchasing Permissions"
                                                                >Purchase</button>

                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </ng-container>

                    </div>

                </div>
            </div>
        </div>
        <router-outlet></router-outlet>
    </div>
    <div class="modal fade" id="exampleModalCenter" tabindex="-1" role="dialog"
        aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <child-header title="Renewal Enquiry" (closeEvent)="closeModal()"></child-header>
                <!-- <div class="modal-header">
                    <h6 class="pop-up-title">Renewal Enquiry</h6>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div> -->


                <!-- <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalCenterTitle">Renewal Enquiry
                        <br>
                        <span style="font-size:12px;">
                            Please enter a comment below, and this will be sent along with the details of this renewal
                            opportunity to our sales team. Somebody will get back in touch with you shortly</span>
                    </h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div> -->
                <div style="margin-top: 10px;" class="modal-body">

                    <p>
                        Please enter a comment below, and this will be sent along with the details of this
                        renewal opportunity to our sales team. Somebody will get back in touch with you
                        shortly.
                    </p>

                    <div class="tab-content" id="pills-tabContent">
                        <div class="tab-pane fade show active" id="upload-text" role="tabpanel"
                            aria-labelledby="pills-home-tab">
                            <div class="upload-content">
                                <div class="enter-code">
                                    <textarea onfocus="this.placeholder=''" maxlength="300" id="stockCodesText" style="width: 100%;
                                        min-height: 194px;
                                        padding: 20px;
                                        border: 1px solid #E6E6E6;
                                        -webkit-box-sizing: border-box;
                                        box-sizing: border-box;
                                        -webkit-box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
                                        box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
                                        border-radius: 5px;" class="pop-up-grey-text" rows="3" cols="50"
                                        [(ngModel)]="enquiry"></textarea>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="align-center my-4">
                    <button id="btnUploadText" class="button button-red button-large" (click)="sendEnquiry()">Send
                        Enquiry</button>
                </div>
                <loading-screen *ngIf="!loadEnquiryContent" backDropWidth="500"
                    (currentLoadingStatus)="onLoading($event)">
                </loading-screen>
            </div>
        </div>
    </div>

    <!-- 
    <ng-template #content let-c="close" let-d="dismiss">
        <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>

        <div class="modal-header">
            <h6 class="pop-up-title">Enquiry</h6>
        </div>
        <div class="modal-body">
            <div class="tab-content" id="pills-tabContent">
                <div class="tab-pane fade show active" id="upload-text" role="tabpanel"
                    aria-labelledby="pills-home-tab">
                    <div class="upload-content">
                        <div class="enter-code">
                            <textarea placeholder="Enter enquiry" onfocus="this.placeholder=''" maxlength="300"
                                onblur="this.placeholder='Enter enquiry'" id="stockCodesText" class="pop-up-grey-text"
                                rows="3" cols="50" [(ngModel)]="enquiry"></textarea>
                        </div>
                        <div class="button-center">
                            <button id="btnUploadText" class="button button-red button-large"
                                (click)="sendEnquiry()">Send
                                Enquiry</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <loading-screen *ngIf="!loadEnquiryContent" backDropWidth="420" (currentLoadingStatus)="onLoading($event)">
        </loading-screen>
    </ng-template> -->

</div>
